import type { Lesson, LessonFormData } from "api/services/content/schemas/lessons";
import type { Locale } from "api/services/content/schemas/shared";
import type { ValidLocale } from "types/validLocale";

export function getDefaultLessonPartValues({
  locale,
  title,
}: {
  locale?: Locale | ValidLocale;
  title?: string;
}): LessonFormData["parts"][number] {
  const lowerCasedLocale = (locale || process.env.REACT_APP_LOCALE || "en-gb").toLowerCase() as Locale;

  return {
    order: 1,
    questions: [],
    translation: {
      locale: lowerCasedLocale,
      title: title || "",
      content: [],
      questions: [],
      image_url: null,
    },
  };
}

interface GetDefaultValuesArgs {
  lesson?: Lesson;
  locale?: ValidLocale;
}

export function getDefaultValues({ lesson, locale }: GetDefaultValuesArgs): LessonFormData {
  const lowerCasedLocale = (locale || process.env.REACT_APP_LOCALE || "en-gb").toLowerCase() as Locale;

  const defaultValues: LessonFormData = {
    id: lesson?.id,
    target_joints: lesson?.target_joints || [],
    parts: lesson?.parts || [getDefaultLessonPartValues({ locale: lowerCasedLocale })],
  };

  return defaultValues;
}
